import React from 'react'

const Contact = () => {
  return (
    <div id="contact">
        <p class="fontSize2 titlePosition">CONTACT</p> 
        <p class="fontSize4 textCenter">何かありましたらこちらにご連絡ください。</p>
        <p class="fontSize4 textCenter">jellyfish.apple200@gmail.com</p> 
    </div>
  )
}

export default Contact